import QtyControlBtns from '@/components/cart/QtyControlBtns';
import TrashIcon from '@/components/icons/trash';
import Image from '@/components/image';
import NextLink from '@/components/next-link';
import CurrencyIcon from '@/components/ui/icons/currency-icon';
import { handlePriceByComma } from '@/helpers/common';
import useHandleCart from '@/hooks/cart/useHandleCart';
import { priceFormatedObject, validatePrice } from '@/utils/category';
import { setCookie } from 'cookies-next';

const MiniCartItem = ({ product }) => {
  const image =
    product?._media_?.image?.at(0)?.image ||
    (product?.extension_attributes?.product_image &&
      `${process.env.NEXT_PUBLIC_IMG_BASEURL}/media/catalog/product/${product?.extension_attributes?.product_image}`) ||
    product?.image_url ||
    `${process.env.NEXT_PUBLIC_IMG_BASEURL}/media/catalog/product/${product?.image}`;
  const price = validatePrice(priceFormatedObject(product));
  const { loading, deleteItemFromCart } = useHandleCart();

  return (
    <li className='border-border flex gap-2.5 border-b p-3'>
      <div className='border-border relative my-auto aspect-square w-17 overflow-hidden rounded-md border p-1'>
        <Image
          src={image}
          alt={product?.name}
          className='size-17 object-contain'
          width={64}
          height={64}
          loading='lazy'
        />
      </div>

      <div className='flex flex-1 flex-col justify-between gap-4 text-sm'>
        <div className='text-primary flex justify-between gap-6'>
          <NextLink
            href={`/${
              product?.innova_url || product?.extension_attributes?.innova_url
            }`}
            onClick={() => setCookie('product_view_type', 'mini-cart')}
            className='line-clamp-2 font-bold'
          >
            {product?.name}
          </NextLink>
          <p className='flex items-center gap-1 self-start font-bold'>
            {handlePriceByComma(
              product?.price_incl_tax ||
                price?.specialPrice ||
                price?.originalPrice
            )}
            <CurrencyIcon className='size-3.5' />
          </p>
        </div>

        <div className='flex justify-between'>
          <QtyControlBtns
            product={product}
            item_id={product?.item_id}
            quantity={product?.qty}
            fromPopup
          />
          <button
            onClick={() => deleteItemFromCart(product, 'mini-cart')}
            disabled={loading === 'deleting'}
            className='flex shrink-0 cursor-pointer self-end disabled:cursor-not-allowed disabled:opacity-75'
          >
            {loading === 'deleting' ? (
              <span className='size-4 animate-spin rounded-full border-t border-r border-black' />
            ) : (
              <TrashIcon className='size-4 text-red-500' />
            )}
          </button>
        </div>
      </div>
    </li>
  );
};

export default MiniCartItem;
